import React, {useState, useEffect} from "react";

import ReactAudioPlayer from "react-audio-player";
import {IonRange} from "@ionic/react";

const playIcon = <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M0 13.0892C0 13.4837 0.435575 13.7228 0.768438 13.511L10.3371 7.42183C10.6459 7.22536 10.6459 6.77465 10.3371 6.57817L0.768438 0.489006C0.435576 0.277185 0 0.516291 0 0.910837V13.0892Z"
        fill="black" fillOpacity="0.5"/>
</svg>
const pauseIcon = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M8.4 16.3C8.4 16.5761 8.62386 16.8 8.9 16.8H10.3C10.5761 16.8 10.8 16.5761 10.8 16.3V7.7C10.8 7.42386 10.5761 7.2 10.3 7.2H8.9C8.62386 7.2 8.4 7.42386 8.4 7.7V16.3ZM12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM12 21.6C6.708 21.6 2.4 17.292 2.4 12C2.4 6.708 6.708 2.4 12 2.4C17.292 2.4 21.6 6.708 21.6 12C21.6 17.292 17.292 21.6 12 21.6ZM13.2 16.3C13.2 16.5761 13.4239 16.8 13.7 16.8H15.1C15.3761 16.8 15.6 16.5761 15.6 16.3V7.7C15.6 7.42386 15.3761 7.2 15.1 7.2H13.7C13.4239 7.2 13.2 7.42386 13.2 7.7V16.3Z"
        fill="black" fillOpacity="0.5"/>
</svg>


const Audio = ({
    srcAudio
}) => {
    const [elementRef, setElementRef] = useState();
    const [loading, setLoading] = useState(true);
    const [isPlaying, setIsPlaying] = useState(false);
    const [playTime, setPlayTime] = useState("00:00");
    const [playTimeRangeValue, setPlayTimeRangeValue] = useState(0);
    const [totalTime, setTotalTime] = useState(0);

    const formatTime = (timeInSeconds) => {
        let sec_num = parseInt(timeInSeconds, 10); // don't forget the second param
        let hours = Math.floor(sec_num / 3600);
        let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        let seconds = sec_num - (hours * 3600) - (minutes * 60);

        if (hours && hours < 10) {
            hours = "0" + hours;
        }
        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        if (seconds < 10) {
            seconds = "0" + seconds;
        }

        if (hours)
            return hours + ':' + minutes + ':' + seconds;
        return minutes + ':' + seconds;

    }

    const processTime = (timeFromEvent) => {
        const formattedTime = formatTime(timeFromEvent)
        setPlayTime(formattedTime)
        console.log(formattedTime)
        if (totalTime) {
            setPlayTimeRangeValue(Number((timeFromEvent / totalTime * 100).toFixed(0)))
        } else {
            setPlayTimeRangeValue(timeFromEvent)
        }
    }

    const setPlayerTime = (rangeSliderValue) => {
        if (totalTime) {
            elementRef.audioEl.current.currentTime = totalTime / 100 * rangeSliderValue
        } else {
            elementRef.audioEl.current.currentTime = rangeSliderValue
        }
    }

    const play = () => {
        if (elementRef?.audioEl) {
            elementRef.audioEl.current.play();
        }
    }
    const pause = () => {
        if (elementRef?.audioEl) {
            elementRef.audioEl.current.pause();
        }
    }
    const onPause = () => {
        setIsPlaying(false)
    }
    const onPlay = () => {
        setIsPlaying(true)
    }
    const onSeeked = (event) => {
        if (event?.target?.currentTime) {
            processTime(event.target.currentTime)
        }
    }
    const onListen = (time) => {
        processTime(time)
        setIsPlaying(true)
    }
    const onEnded = () => {
        setPlayTimeRangeValue(100);
        setIsPlaying(false)
    }
    const onCanPlayThrough = (event) => {

        setLoading(false);
        if (event?.target?.duration) {
            if (event?.target.duration === Infinity) {
                //хак для хрома
                elementRef.audioEl.current.currentTime = 1000000;
            } else {
                setTotalTime(event.target.duration)
            }
        }
    }
    const onCanPlay = (event) => {

        setLoading(false);
        if (event?.target?.duration) {
            setTotalTime(event.target.duration)
        }

    }


    return <div className="audio-player">
        <div className="audio-player-range">
            {!isPlaying && <div onClick={play} className="audio-player-range-btn">
                {playIcon}
            </div>}
            {isPlaying && <div onClick={pause} className="audio-player-range-btn">
                {pauseIcon}
            </div>}
            <div className="audio-player-time audio-player-time_right">
                {playTime}
            </div>
            <IonRange value={playTimeRangeValue} pinFormatter={(value) => `${formatTime(value)}`} onIonKnobMoveEnd={({detail}) => setPlayerTime(detail.value)}/>
        </div>
        <div className="audio-player-time audio-player-time_left">
            {formatTime(totalTime)}
        </div>
        <ReactAudioPlayer src={srcAudio}
                          onPause={onPause}
                          onPlay={onPlay}
                          onSeeked={onSeeked}
                          onListen={onListen}
                          onEnded={onEnded}
                          ref={(element) => {
                              setElementRef(element);
                          }}
                          onCanPlayThrough={onCanPlayThrough}
                          onLoadedMetadata={onCanPlayThrough}
                          onCanPlay={onCanPlay}
                          listenInterval={333}
        />
    </div>
}

export const AudioWrapper = React.memo(Audio);

export const AudioClock = () => {
    const [Time, setTime] = useState({
        currentTime: 0,
        lastTime: Date.now()
    });

    useEffect(() => {
        const tick = setInterval(() => {
            setTime({
                currentTime: Time.currentTime + (Date.now() - Time.lastTime),
                lastTime: Date.now()
            });
        }, 1000);

        return () => {
            clearTimeout(tick);
        }
      }, []);

    function parseTime(time) {
        const date = new Date(time);
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();
        return {
            minutes,
            seconds
        }
    }

    const time = parseTime(Time.currentTime);

    return <>
        {time.minutes.toString().padStart(2, "0")}:
        {time.seconds.toString().padStart(2, "0")}
    </>
}